module.exports = __webpack_public_path__ + "img/activity.e760862f.svg";